<div [ngClass]="parentClass">
  <div [ngClass]="indentClass">{{ value }}</div>
</div>
